<template>
  <div class="doctor-info-main" v-if="showData">
    <div class="doctor-info-container show-flex-box-r">
      <span>
        <img :src="showData.avatarUrl">
      </span>
      <div class="show-flex-box-r doctor-info-bar">
        <dl class="show-flex-box-c">
          <dt class="show-flex-box-r">
            <strong class="hide-line1">{{ showData.name }}</strong>
            <h3 class="show-flex-box-r show-flex-center">
              <span>已认证</span>
            </h3>
          </dt>
          <dd class="show-flex-box-c">
            <span class="hide-line1" v-if="showData.hospital">{{ showData.hospital }}</span>
            <span class="hide-line1" v-if="showData.field">{{ showData.field }}</span>
          </dd>
        </dl>
      </div>
      <!-- <div class="show-flex-box-r sub-btn-bar" @click.stop="subThisDoctor()">
        <div :class="{'show-flex-box-r show-flex-center':true, 'is-sub': showData.isSub == 1}">
          <em v-if="!showData.isSub"></em>
          <span>{{ showData.isSub ? '已关注' : '关注' }}</span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

export default{
  props: {
    showInfo: [Object]
  },
  data() {
    return {
      showData: null,

    };
  },
  mounted() {
    this.setShowContent();
  },
  watch: {
    showInfo() {
      this.setShowContent();
    }
  },
  methods: {
    setShowContent() {
      if (!this.showInfo) {
        return ;
      }

      this.showData = this.showInfo;
    },
    subThisDoctor(){
      let sendInfo = {
        id: this.showData.id,
        type: this.showData.type,
        status: this.showData.isSub
      };

      this.$emit('clickSubBtn', sendInfo);
    },

  },
};
</script>

<style lang="less">
.doctor-info-main {
  width: 100%;
  height: 100%;
  > .doctor-info-container {
    width: 100%;
    height: 100%;
    align-items: center;
    > span {
      width: 0.5rem;
      height: 0.5rem;
      margin-right: 0.12rem;
      flex-shrink: 0;
      border-radius: 50%;
      overflow: hidden;
      > img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    > .doctor-info-bar {
      width: 0;
      flex-grow: 1;
      height: 100%;
      align-items: center;
      > dl{
        width: 100%;
        // height: 100%;
        // justify-content: space-between;
        > dt{
          width: 100%;
          align-items: center;
          margin-bottom: 2px;
          > strong{
            max-width: 1.5rem;
            margin-right: 0.04rem;
            font-size: 0.14rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 0.2rem;
          }
          > h3{
            box-sizing: border-box;
            width: 0.42rem;
            height: 0.16rem;
            flex-shrink: 0;
            border-radius: 0.08rem;
            border: 1px solid #4BDC00;
            > span{
              font-size: 0.1rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #05BE00;
              line-height: 0.14rem;
            }
          }
        }
        > dd{
          width: 100%;
          > span{
            width: 100%;
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 0.16rem;
          }
        }
      }
    }
    > div{
      box-sizing: border-box;
      width: 0.56rem;
      height: 0.24rem;
      margin-left: 0.1rem;
      > div{
        width: 100%;
        height: 100%;
        background: rgba(5, 190, 0, 0.18);
        border-radius: 12px;
        > em{
          width: 0.1rem;
          height: 0.1rem;
          flex-shrink: 0;
          margin-right: 0.02rem;
          background: url('../../assets/course/follow_add.png') center center no-repeat;
          background-size: 100% 100%;
        }
        > span{
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #05BE00;
          line-height: 0.16rem;
        }
      }
      > .is-sub{
        background: #EFEFEF;
        > span{
          color: #999;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/doctor_info_comp.vue